import $store from '@/store/index'

class LoginHelper {
  constructor () {
    $store.dispatch('auth/checkLoginStatus')
    this.changeInterval()
  }

  changeInterval (newInterval = 60000) {
    if (this.interval) {
      clearInterval(this.interval)
    }

    this.interval = setInterval(() => {
      $store.dispatch('auth/checkLoginStatus')
    }, newInterval)
  }

  destroy () {
    clearInterval(this.interval)
  }
}

const LoginHelperInstance = new LoginHelper()

export default LoginHelperInstance
